import React, {useState} from "react";
import {BsFacebook, BsInstagram, BsLinkedin, BsTiktok, BsYoutube} from "react-icons/bs";
import {useTranslation} from "react-i18next";

export const SocialIcons = ({size = undefined, color = "text-white"}) => {
    const {t} = useTranslation();
    const [socialLinks] = useState([
        {
            name: "Instagram",
            url: "https://www.instagram.com/dmarcflow",
            icon: <BsInstagram size={size}/>,
        },
        {
            name: "LinkedIn",
            url: "https://www.linkedin.com/company/dmarcflow",
            icon: <BsLinkedin size={size}/>,
        },
        {
            name: "TikTok",
            url: "https://www.tiktok.com/@dmarcflow",
            icon: <BsTiktok size={size}/>,
        },
        {
            name: "Facebook",
            url: "https://www.facebook.com/people/DMARCflow",
            icon: <BsFacebook size={size}/>,
        },
        {
            name: "YouTube",
            url: "https://www.youtube.com/@dmarcflow",
            icon: <BsYoutube size={size}/>,
        },
    ]);

    return (
        socialLinks.map((link) => (
            <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("pages.home.followUs.aria", {
                    platform: link.name,
                })}
                // style={{color: "#000"}}
                className={"me-2 " + color}
            >
                {link.icon}
            </a>
        ))
    )
}